export function getSupportLoading(state) {
    return state.SupportReducer.isLoading;
}

export function getSupports(state) {
    return state.SupportReducer.supports;
}